import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, defineComponent, ref } from 'vue';
import { clamp, useRAF } from '@/shared/lib';
export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleCircularTimer',
  props: {
    duration: {
      type: Number,
      default: 10000
    }
  },
  emits: ["timer-expired"],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    defineComponent({
      name: 'SimpleCircularTimer'
    });
    var viewBoxSize = 100;
    var maxThickness = 12;
    var radius = computed(function () {
      return viewBoxSize / 2 - maxThickness / 2;
    });
    var circleLengthMax = computed(function () {
      return 2 * Math.PI * (50 - maxThickness / 2);
    });
    var strokeDasharray = ref(circleLengthMax.value);
    var thickness = computed(function () {
      return Math.min(maxThickness, Math.floor(strokeDasharray.value * 3));
    });
    var remainsSeconds = ref(Math.round(props.duration / 1000));
    var timeGone = 0;
    function timerStopCondition() {
      return props.duration <= timeGone;
    }
    function frame(elapsed) {
      timeGone += elapsed;
      var part = timeGone / props.duration;
      strokeDasharray.value = clamp(Math.floor(circleLengthMax.value * (1 - part)), 0, circleLengthMax.value);
      remainsSeconds.value = Math.round((props.duration - timeGone) / 1000);
      var stop = timerStopCondition();
      if (stop) {
        emit('timer-expired');
      }
      return !stop;
    }
    var animation = useRAF(frame);
    function reset() {
      timeGone = 0;
    }
    function restart() {
      reset();
      animation.start();
    }
    function start() {
      animation.start();
    }
    function stop() {
      animation.stop();
    }
    expose({
      restart: restart,
      reset: reset,
      start: start,
      stop: stop
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      viewBoxSize: viewBoxSize,
      maxThickness: maxThickness,
      radius: radius,
      circleLengthMax: circleLengthMax,
      strokeDasharray: strokeDasharray,
      thickness: thickness,
      remainsSeconds: remainsSeconds,
      timeGone: timeGone,
      timerStopCondition: timerStopCondition,
      frame: frame,
      animation: animation,
      reset: reset,
      restart: restart,
      start: start,
      stop: stop
    };
  }
});